import { render } from "./ArticleUnderstandingButtons.vue?vue&type=template&id=5754f955&scoped=true"
import script from "./ArticleUnderstandingButtons.vue?vue&type=script&lang=js"
export * from "./ArticleUnderstandingButtons.vue?vue&type=script&lang=js"

import "./ArticleUnderstandingButtons.vue?vue&type=style&index=0&id=5754f955&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5754f955"]])

export default __exports__